export default __webpack_public_path__ + "static/ibmplexmono-thin-2208d16cf99042043a3420bad5b12525.woff2";